import Block from '@components/Layout/Block';
import { VerticalLineSeparator } from '@components/MiscComponents/VerticalLineSeparator';
import { color, font, query } from '@design/templateFns';
import React, { FC, useEffect } from 'react';
import styled from 'styled-components';

interface PropertyDetailTextBlockProps {
  header?: string;
  body?: string;
  swatch?: string;
}

const PropertyDetailTextBlock: FC<PropertyDetailTextBlockProps> = ({ header, body, swatch }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const toggleForm = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    body ? setIsOpen(false) : setIsOpen(true);
  }, [body]);

  let columnOne;
  let columnTwo;
  let s = body;

  if (s) {
    s = s.replaceAll('<br>', '\n');

    let middle = Math.floor(s.length / 2);
    let before = s.lastIndexOf(' ', middle);
    let after = s.indexOf(' ', middle + 1);

    if (middle - before < after - middle) {
      middle = before;
    } else {
      middle = after;
    }

    columnOne = s.substring(0, middle);
    columnTwo = s.substring(middle + 1);
  }

  return (
    <Block narrow background={swatch == 'cream' ? 'secondaryBg' : 'bg'}>
      <ContentContainer>
        {header && (
          <>
            <Header data-testid="property-detail-header">{header}</Header>
            <VerticalLineSeparator />
          </>
        )}
        <TextWrapper data-testid="property-detail-description">
          {columnOne && <Text data-testid="description-col-one">{columnOne}</Text>}
          {columnTwo && <Text2 data-testid="dexription-col-two">{columnTwo}</Text2>}

          <ReadMoreWrapper $isOpen={isOpen}>
            <Text>{columnTwo}</Text>
          </ReadMoreWrapper>
          {columnOne && (
            <ReadMore data-testid="description-read-more" onClick={toggleForm}>
              {isOpen ? 'Read Less' : 'Read More'}
            </ReadMore>
          )}
        </TextWrapper>
      </ContentContainer>
    </Block>
  );
};

export default PropertyDetailTextBlock;

export const ContentContainer = styled.div`
  margin-top: 44px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  color: ${color('fg')};
  @media screen and (${query.atLeast('tablet')}) {
    margin-top: 100;
    margin-top: 48px;
  }
`;

export const Header = styled.h1`
  ${font('headline-xl')};
  line-height: 1.1;
  max-width: 838px;
  margin-left: auto;
  margin-right: auto;
  padding: 0;
  text-align: center;
  @media screen and (${query.below('tablet')}) {
    ${font('headline-sm')};
    line-height: 1.1;
  }
`;

export const Text = styled.div`
  ${font('body-sm-light')};
  color: ${color('fg')};
  font-size: 14px;
  text-align: left;
  white-space: pre-line;
  margin-bottom: 24px;
  p {
    margin: 0;
  }
  @media screen and (${query.atLeast('tablet')}) {
    ${font('body-md-light')};
    max-width: 500px;
  }
`;

export const Text2 = styled.div`
  ${font('body-sm-light')};
  color: ${color('fg')};
  text-align: left;
  white-space: pre-line;
  margin-bottom: 24px;
  p {
    margin: 0;
  }
  display: none;
  @media screen and (${query.atLeast('tablet')}) {
    ${font('body-md-light')};
    max-width: 515px;
    display: block;
  }
`;
export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  @media screen and (${query.atLeast('tablet')}) {
    flex-direction: row;
    justify-content: center;
    gap: 40px;
  }
`;

export const ReadMore = styled.div`
  display: block;
  width: 69px;
  ${font('subhead-xs')};
  color: ${color('fg')};
  border-bottom: 1px solid #000000;
  cursor: pointer;
  @media screen and (${query.atLeast('tablet')}) {
    display: none;
  }
`;

export const ReadMoreWrapper = styled.div<{ $isOpen: boolean }>`
  max-height: ${({ $isOpen }) => ($isOpen ? 'none' : '0')};
  line-height: ${({ $isOpen }) => ($isOpen ? '134%' : '0%')};
  opacity: ${({ $isOpen }) => ($isOpen ? '1' : '0')};
  transition: all 0.5s ease-in-out;
  overflow: hidden;
  display: block;
  @media screen and (${query.atLeast('tablet')}) {
    display: none;
  }
`;
